module.exports = __webpack_public_path__ + "img/rank-icon.52cceef5.svg";